import { Card, CardBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import stopIcon from 'src/assets/icons/stop.svg';

import { I18NextNS } from 'src/models/Language.model';

export default function ReconnectionFailedCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'connectionIssue.reconnectionFailedCard',
  });

  return (
    <Card
      bg="danger-100"
      className="border-0 overflow-hidden position-relative"
    >
      {/* Cannot use border because inner radius will be rounded */}
      <div
        className="bg-danger position-absolute top-0 start-0 h-100"
        style={{ width: '4px' }}
      />
      <CardBody>
        {/* Have to use divs instead of bootbox grid because Alison's spacing is smaller than what bootbox allows */}
        <div>
          <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: '2rem' }}
            >
              <img src={stopIcon} alt={t('imgAlt')} />
            </div>
            <div style={{ paddingLeft: '0.5rem' }}></div>
            <div className="d-flex flex-column justify-content-center flex-grow-1">
              <h6 className="mb-1">{t('title')}</h6>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
